import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  API_ROOT_URL,
  CAMERA_ANGLE_PRESET,
  PRESET_CAMERA_ANGLE,
  PRESET_CAMERA_IMPORT,
} from '../../config/constant/apiConstant';
import api from '../../helpers/axiosHelper';
import { successToast, errorToast } from '../../helpers/toastHelper';
import {
  addCameraPresetAngleList,
  addToPresetsSuccess,
  cameraAngleSelector,
  getCameraPresetAnglesList,
  setAddToPresetsLoading,
  setCameraPresetAnglesList,
  setCreateCameraPresetStatus,
  setDeleteCameraPresetStatus,
} from '../../redux/slicers/camera/cameraAngleSlicer';
import {
  importCameraPresetsSuccess,
  setImportPresetsLoading,
} from '../../redux/slicers/camera/projectCameraAngleSlicer';
import { parseCamera } from './projectCamera';
import { LogCurator } from '../../helpers/logEvents';
import { decimals } from '../../helpers/jsHelper';

export const getPresetCameraAngleAPI =
  ({ projectId, roomId }) =>
  (dispatch) => {
    let query = 'per_page=100';

    if (projectId) {
      query += `&project_id=${projectId}`;
    }
    
    if (roomId) {
      query += `&room_id=${roomId}`;
    }

    // const loadsRoomAndProjectData = Boolean(projectId && roomId);

    api()
      .root(API_ROOT_URL)
      .get(`${PRESET_CAMERA_ANGLE}?${query}`)
      .success((data) => {
        LogCurator('get preset camera angle api success: ', data.results);

        var res = [];

        data.results.forEach(function (a) {
          const isRoom = Boolean(a.room);

          delete a.project;
          delete a.room;

          const tempItem = {
            ...a,
            id: a.id,
            cameraName: a.cameraName,
            fov: decimals(a.fov, 3),
            isCameraCorrection: a.isCameraCorrection,
            cameraHeight: decimals(a.cameraHeight, 2),
            isdepthOfField: a.isdepthOfField,
            selectedObjectName: a.selectedObjectName,
            blurIntensity: decimals(a.blurIntensity, 4),
            distanceToSet: decimals(a.distanceToSet, 4),

            resoX: Number.parseInt(a.resoX),
            resoY: Number.parseInt(a.resoY),

            focalLength: decimals(a.focalLength,4),
            xTransRot: decimals(a.xTransRot, 4),
            yTransRot: decimals(a.yTransRot, 4),
            zTransRot: decimals(a.zTransRot, 4),
            xPos: decimals(a.xPos, 4),
            yPos: decimals(a.yPos, 4),
            zPos: decimals(a.zPos, 4),
            centerObjectxPos: decimals(a.centerObjectxPos, 4),
            centerObjectyPos: decimals(a.centerObjectyPos, 4),
            centerObjectzPos: decimals(a.centerObjectzPos, 4),
            cameraRotX: decimals(a.cameraRotX, 4),
            cameraRotZ: decimals(a.cameraRotZ, 4),
            lensShiftY: decimals(a.lensShiftY, 4),

            sensor_width: decimals(a.sensor_width, 3),
            sensor_height: decimals(a.sensor_height, 3),

            member: a.member,
            isRoom,
          };

          res.push(tempItem);
        });

        LogCurator('res preset: ', res);

        if (data.results.length !== 0) {
          dispatch(setCameraPresetAnglesList(res));
        }
      })
      .error((error) => {
        LogCurator('get camera angle api error: ', error);
      })
      .send();
  };

export const createPresetCameraAngleAPI =
  (formData, { onSuccess } = {}) =>
  (dispatch) => {
    const headers = { 'Content-Type': 'multipart/form-data' };
    // const { getCameraPresetAnglesList } = useSelector(cameraAngleSelector)

    dispatch(setAddToPresetsLoading(true));
    api()
      .root(API_ROOT_URL)
      .post(PRESET_CAMERA_ANGLE)
      .data(formData)
      .setHeaders(headers)
      .success((data) => {
        const parsedCaemra = parseCamera(data.data);
        dispatch(addToPresetsSuccess(parsedCaemra));
        // dispatch(setCreateCameraPresetStatus(data.status))
        LogCurator('create preset camera angle api success: ', data.data);
        successToast('Your camera has been succesfully saved.', 'Preset Saved ');
        onSuccess?.();
      })
      .error((error) => {
        // dispatch(setCreateCameraPresetStatus(error.status))

        LogCurator('create preset camera angle api error: ', error);
        errorToast('Unable to save camera to Preset!');
      })
      .finally(() => {
        dispatch(setAddToPresetsLoading(false));
      })
      .send();
  };

// export const updatePresetCameraAngleAPI = (formdata) => {
//     LogCurator("Curator",formdata);

//     // cons

//     api().root(API_ROOT_URL).post(PRESET_CAMERA_ANGLE).data(formdata).success((data)=>{

//         // dispatch(setSearchResult(data))
//         LogCurator("update camera angle api success: ", data)

//         // setLocalStorage("renderStatus", data.status)

//     }).error((error)=>{
//         // dispatch(setSearchResult(error))
//         LogCurator("update camera angle api error: ", error)

//         // setLocalStorage("renderStatus", error.status)
//     }).send()

// }

export const deletePresetCameraAngleAPI = (id) => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .delete(`${PRESET_CAMERA_ANGLE}${id}/`)
    .success((data) => {
      LogCurator('delete camera angle api success: ', true);
      // dispatch(setDeleteCameraPresetStatus(true))
      successToast('Camera preset deleted successfully!');
    })
    .error((error) => {
      LogCurator('delete camera angle api error: ', false);
      // dispatch(setDeleteCameraPresetStatus(false))
      errorToast('Unable to delete camera preset!');
    })
    .send();
};

export const importPresetCameraAngleAPI = (formData) => (dispatch) => {
  const headers = { 'Content-Type': 'multipart/form-data' };

  dispatch(setImportPresetsLoading(true));

  return api()
    .root(API_ROOT_URL)
    .post(PRESET_CAMERA_IMPORT)
    .data(formData)
    .setHeaders(headers)
    .success((data) => {
      const cameraList = data.data.map(parseCamera)
      dispatch(importCameraPresetsSuccess(cameraList));
      LogCurator('import preset camera angle api success: ', data);
      successToast('Your camera has been succesfully added.', 'Camera Added');
    })
    .error((error) => {
      // dispatch(setCreateCameraPresetStatus(error.status))
      LogCurator('import preset camera angle api error: ', error);
      errorToast('Unable to import camera preset!');
    })
    .finally(() => {
      dispatch(setImportPresetsLoading(false));
    })
    .send();
};

export const createPresetCameraAPI =
  (formData, { onSuccess } = {}) =>
  (dispatch) => {
    const headers = { 'Content-Type': 'multipart/form-data' };

    dispatch(setAddToPresetsLoading(true));

    return new Promise((resolve, reject) => {
      api()
        .root(API_ROOT_URL)
        .post(CAMERA_ANGLE_PRESET)
        .data(formData)
        .setHeaders(headers)
        .success((data) => {
          const parsedCamera = parseCamera(data.data);

          LogCurator('create preset camera angle api success: ', data.data);
          successToast(
            'Your camera has been succesfully saved.',
            'Preset Saved '
          );

          onSuccess?.(parsedCamera);

          resolve(parsedCamera); // THIS is what dispatch returns
        })
        .error((error) => {
          LogCurator('create preset camera angle api error: ', error);
          errorToast('Unable to save camera to Preset!');
          reject(error); // allow try/catch
        })
        .finally(() => {
          dispatch(setAddToPresetsLoading(false));
        })
        .send();
    });
  };

export const deletePresetCameraAPI = (id) => {
  api()
    .root(API_ROOT_URL)
    .delete(`${CAMERA_ANGLE_PRESET}${id}/`)
    .success((data) => {
      LogCurator('delete project camera angle api success: ', data);
    })
    .error((error) => {
      LogCurator('delete project camera angle api error: ', error);
    })
    .send();
};